/**
 * A list of partner logos to display in the PartnerLogos component.
 */
export const getPartnersLogos = udLink => [{
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/volkswagen.svg'),
  name: 'Volkswagen',
  width: 48,
  height: 48
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/samsung.svg'),
  name: 'Samsung',
  width: 101,
  height: 34
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/cisco.svg'),
  name: 'Cisco',
  width: 87,
  height: 40
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/att.svg'),
  name: 'ATT&T',
  width: 97,
  height: 40
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/procter_gamble.svg'),
  name: 'Procter & Gamble',
  width: 48,
  height: 48
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/hewlett_packard_enterprise.svg'),
  name: 'Hewlett Packard Enterprise',
  width: 94,
  height: 40
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/citi.svg'),
  name: 'Citi',
  width: 62,
  height: 40
}, {
  img: udLink.toStorageStaticAsset('partner-logos/ou-v1/ericsson.svg'),
  name: 'Ericsson',
  width: 55,
  height: 48
}];
export const getPartnersBannerHeading = (i18nApi, getOrgNumericSiteStat) => i18nApi.interpolate(i18nApi.gettext('Trusted by over %(teams)s companies and millions of learners around the world'), {
  teams: getOrgNumericSiteStat('num_enterprise_customers')
}, true);
//# sourceMappingURL=constants.js.map